import type { SelectValueType } from '~/presentation/reports/ui/type';
import type { CampaignConfigType } from '../../SelectCampaignContent';

import { PopoverActionList, PopoverChoice } from '~/presentation/reports/ui/SelectPopover';
import { useSearch } from '~/presentation/reports/ui/SelectPopover/hooks';
import { SearchField } from '~/presentation/reports/ui/SearchFiled';
import { SelectVariantType } from '~/presentation/reports/ui/type';
import { Popover, Box, Scrollable } from '@shopify/polaris';
import { CampaignActionList } from './CampaignActionList';
import { CampaignChoice } from './CampaignChoice';
import { useState, useMemo } from 'react';

export interface SelectCampaignPopoverProps extends CampaignConfigType {
  activator: React.ReactElement;
  popoverActive: boolean;
  togglePopoverActive: (value: boolean) => void;
  isShowNoData?: boolean;
  header?: React.ReactNode;
  onChangeValue?: (id: string, value: SelectValueType) => void;
  variant: SelectVariantType;
  isOperator?: boolean;
  campaignGroupId?: string;
}

export const SelectCampaignPopover: React.FC<SelectCampaignPopoverProps> = ({
  width,
  header,
  ...props
}) => {
  const { activator, popoverActive, togglePopoverActive, isShowSearch } = props;
  const [queryValue, setQueryValue] = useState('');

  const { options } = useSearch({
    options: props.options,
    queryValue,
  });

  const popoverContent = useMemo(() => {
    switch (props.variant) {
      case SelectVariantType.ACTION_LIST:
        if (props.isOperator) {
          return <PopoverActionList {...props} options={options} />;
        }

        return <CampaignActionList {...props} />;
      case SelectVariantType.CHOICE:
        if (props.isOperator) {
          return <PopoverChoice {...props} options={options} />;
        }

        return <CampaignChoice {...props} />;
    }
  }, [props, options]);

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={() => togglePopoverActive(false)}
    >
      <Box width={width}>
        {header}
        {isShowSearch && (
          <Box padding="300" paddingBlockEnd="050" paddingBlockStart={header ? '0' : '300'}>
            <SearchField queryValue={queryValue} onSearch={setQueryValue} />
          </Box>
        )}
        <Scrollable vertical scrollbarWidth="thin" horizontal={false}>
          {popoverContent}
        </Scrollable>
      </Box>
    </Popover>
  );
};
